<div class="notification-panel">
  <div *ngIf="loaded" class="action-bar">
    <div class="spacer"></div>

    <div class="right-section">
      <mat-form-field *ngIf="notifications.length > 0" appearance="fill" class="search-field transparent-background">
        <input (keyup)="applyFilter($event)" matInput placeholder="{{ 'ACTIONS.FILTER' | translate }}" #input />
      </mat-form-field>

      <button mat-button id="refresh-btn" (click)="$event.stopPropagation(); refreshNotifications()">
        <mat-icon [@rotatedState]="state">cached</mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="loaded && notifications.length > 0">

    <h2 style="margin-left: 2rem">{{ "NOTIFICATIONS.NOTIFICATIONS" | translate }}</h2>

    <mat-chip-listbox selectable style=" margin: 1rem;" class="flex center">
      <mat-chip-option [matBadge]="notificationsCountRead" [selected]="typeOfFilter === 'read'"
        (click)="$event.stopPropagation(); filterRead(true)">
        {{ "NOTIFICATIONS.READ" | translate }}
      </mat-chip-option>
      <mat-chip-option [matBadge]="notificationsCountNotRead" [selected]="typeOfFilter === 'unread'"
        (click)="$event.stopPropagation(); filterRead(false)">
        {{ "NOTIFICATIONS.UNREAD" | translate }}
      </mat-chip-option>
      <mat-chip-option [matBadge]="notificationsCount" [selected]="typeOfFilter === 'all'"
        (click)="$event.stopPropagation(); filterRead(null)">
        {{ "NOTIFICATIONS.ALL" | translate }}
      </mat-chip-option>
    </mat-chip-listbox>

    <div class="action-buttons">
      <button mat-stroked-button color="accent" (click)="setAllRead()">
        {{"NOTIFICATIONS.SET_ALL_AS_READ" | translate}}
      </button>
      <button mat-raised-button color="warn" (click)="deleteAllNotifications()">
        {{"ACTIONS.DELETE_ALL" | translate}}
      </button>
    </div>

    <div class="notification-viewport">
      <div *ngFor="let n of notificationsFiltered" class="notification-item">
        <div class="separator"></div>
        <app-notification-row [notification]="n"></app-notification-row>
      </div>
    </div>
  </div>
  <div *ngIf="loaded && notifications.length < 1" class="center">
    <h3> {{"NOTIFICATIONS.NO_NOTIFICATIONS" | translate}}</h3>
  </div>
</div>
